module.exports = __webpack_public_path__ + "static/media/8.f442f3c9.png";